import React, { ReactChild, CSSProperties } from 'react';
import { Icon } from '@tencent/spaui';
import './index.scoped.less';

export interface StaticTipProps {
  /**
   * 样式
   */
  style?: CSSProperties;
  /**
   * 子元素
   */
  children: ReactChild;
  /**
   * 是否使用flex布局
   */
  flex?: boolean;
}

export const StaticTip: React.FC<StaticTipProps> = (props) => {
  const { children, style = {} } = props;

  return (
    <span style={style} className={`custom-static-tip ${props.flex ? 'flex-layout' : ''}`}>
      <Icon className="custom-static-tip-icon" name="info-filled" />
      <span className="custom-static-tip-content">{children}</span>
    </span>
  );
};

StaticTip.defaultProps = {
  style: {},
};

export default StaticTip;
